import type { Event } from '@patsnap/tahiti-core/common/event';
import type {
    SpecificationJurisdictionOption,
    SpecificationTaskCreateSubmitResult,
    SpecificationTaskCreatePayload,
    SpecificationTaskCreatePayloadErrors,
    SpecificationTaskCreateState,
} from '../types/specification-task-create';

export const SpecificationTaskCreateService = Symbol.for('SpecificationTaskCreateService');

export interface SpecificationTaskCreateService {
    readonly onStateChange: Event<SpecificationTaskCreateState>;

    /**
     * 初始化, 如果内部状态已准备好, 则直接返回
     * @param taskId 任务ID
     */
    init(taskId: string): Promise<void>;

    /** 获取状态 */
    getState(): SpecificationTaskCreateState;

    /** 设置表单数据 */
    setFormData(payload: Partial<SpecificationTaskCreatePayload>): void;

    /** 校验表单数据 */
    validateFormData(): Promise<SpecificationTaskCreatePayloadErrors>;

    /** 获取表单校验错误信息 */
    getFormErrors(): SpecificationTaskCreatePayloadErrors;

    /** 获取可选受理局 */
    getJurisdictions(): SpecificationJurisdictionOption[];

    /**
     * 提交
     * 先校验输入是否正确
     * 再校验输入语言是否正确
     * 最后提交用户输入创建任务
     * !!! 会切换到下一个步骤
     */
    submit(): Promise<SpecificationTaskCreateSubmitResult>;
}
